import React from 'react'
import { Alert, Col, Row } from 'react-bootstrap'

const Message = ({
    show,
    handleClose,
    variant,
    message
}) => {
  return (
    <Row>

        <Col md={9}>

            <Alert
                variant={variant}
                show={show}
                onClose={handleClose}
                dismissible>
                    {message}
                </Alert>
        
        </Col>

    </Row>
  )
}

export default Message